/* Style imports  */
//import 'normalize.css/normalize.css';
import './styles/vendor.scss';
import './styles/core.scss';
import './js/menu.js';
import './js/guides.js';

/**
 * Script module imports
 */
import {
   isTouchMode,
   hasWebpSupport,
   isIOS,
   isIE
} from './js/utils'


const isDev = process.env.NODE_ENV === "development"




/**
 * Agrega clases de detección al elemento 'html'
 */
const addHTMLClasses = () => {

   // Add touch mode class
   if (isTouchMode()) {
      document.documentElement.classList.add('touch-mode')
   }

   if (hasWebpSupport()) {
      document.documentElement.classList.add('supports-webp')
   }

   if (isIOS()) {
      document.documentElement.classList.add('ios')
   }

   if (isIE()) {
      document.documentElement.classList.add('ie')
   }
}





;(function (d, $) {
   $(function () {

      /**
       * Add referential and support body classes
       */
      addHTMLClasses()

   })

})(document, jQuery);


